import { render, staticRenderFns } from "./PostCsv.vue?vue&type=template&id=34f1cfa8&scoped=true&lang=true&"
import script from "./PostCsv.vue?vue&type=script&lang=js&"
export * from "./PostCsv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f1cfa8",
  null
  
)

export default component.exports